var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    fill: _vm.fill,
    [_vm.color]: ['primary', 'danger', 'secondary', 'success'].includes(_vm.color),
    [_vm.size]: ['small', 'medium', 'large'].includes(_vm.size),
  },on:{"click":function($event){return _vm.$emit('handle:click')}}},[(_vm.text)?[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }